import { Component, Input } from '@angular/core';
import { FormGroup, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'ls-form-checkbox',
  templateUrl: 'ls-form-checkbox.component.html',
  styleUrls: ['ls-form-checkbox.component.scss']
})
export class LsFormCheckboxComponent implements ControlValueAccessor {
  @Input()
  public description: string;
  @Input()
  public disabled: boolean;
  @Input()
  public key: string;
  @Input()
  public title: string;
  @Input()
  public value: boolean;
  @Input()
  public visible: boolean;
  @Input()
  public form: FormGroup;

  public writeValue(value: any): void {
    this.value = value;
  }

  public registerOnChange(): void {
    return;
  }

  public registerOnTouched(): void {
    return;
  }
}
